<template>
  <div id="header">
    <div class="d-flex align-center">
      <div class="mr-3">
        <v-btn @click="collapse()" icon color="white">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>

      <div style="height: 62px">
        <img width="185" :src="logo" />
      </div>
    </div>

    <div id="user-name" @click="logout()" role="button">Sair</div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import LogoIMG from '@/assets/img/Logo_Mercado_Link.png';

export default {
  name: 'Header',
  data: () => ({
    logo: LogoIMG
  }),
  computed: {
    ...mapGetters('SidebarStore', ['isCollapsed'])
  },
  methods: {
    ...mapMutations('LoginStore', ['setLogged']),
    ...mapActions('SidebarStore', ['changeCollapse']),

    logout() {
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      this.setLogged(false);

      this.$router.push('/');
    },

    collapse() {
      this.changeCollapse(!this.isCollapsed);
    }
  }
};
</script>

<style lang="scss" scoped>
#header {
  z-index: 100;
  position: fixed;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $--color-secundary;
  padding: 0px 50px 0 10px;

  #user-name {
    color: $--color-white;
  }
}
</style>
